var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScandicdev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "220 220 840 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #0070db;\n      }\n\n      .st1 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient);\n      }\n\n      .st6 {\n        isolation: isolate;\n      }\n\n      .st7 {\n        fill: #ffffff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 269.27,
    y1: 334.02,
    x2: 411.3,
    y2: 334.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003579"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0255a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003678"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 253.96,
    y1: 358.72,
    x2: 431.66,
    y2: 251.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1b82e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24639f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 249.55,
    y1: 397.51,
    x2: 406.81,
    y2: 348.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002d65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00418c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 258.39,
    y1: 334.47,
    x2: 415.55,
    y2: 235.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#398bd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#4f99d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#85bbe6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#b0d5f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#cee9f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#e1f4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e8f9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e0f4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#cae7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#a7d2ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#76b5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#3891d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c8ad2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 254.67,
    y1: 432.7,
    x2: 438.73,
    y2: 332.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#022c60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#70bdf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b83d9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M315.72,309.53s25.4-4.59,36.5-4.28c8.01.22,30.28,1.18,37.76,4.42s21.32,12.71,21.32,12.71l-8.61,15.53-26.98,17.27s-29.32,6.87-44.14,7.44-44.08,0-48.59-2.82-13.69-14.26-13.69-14.26l35.01-37.84,11.44,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.8,360.19s-14.82-5.51-8.89-19.06c2.38-5.43,18.71-20.26,27.81-25.27,0,0,31.57-18.24,44.61-23.72,9.74-4.09,55.63-23.62,60.59-25.51,7.78-2.96,16.14-6.39,18.05-7.95,1.58-1.29,4.24-6.07-.56-15.67s-89.22,43.06-89.22,43.06l-65.51,40.94-5.36,22.73,18.49,10.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.33,417.51s.21-5.08,2.82-7.34c3.98-3.44,17.98-6.64,23.06-8.19,3.92-1.2,39.57-14.5,55.13-22.09s47.44-23.72,50.85-25.91c2.51-1.61,27.67-16.09,32.33-22.31s-27.74,30.14-27.74,30.14l-64.09,31.81-65.51,18.92-6.85,4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M290.86,361.56s-31.44-8.63-8.34-33.77c22.22-24.17,70.63-43.08,85.74-49.08,1.85-.74,22.17-8.72,25.13-10.07,7.48-3.42,30.7-9.79,34.65-13.79,2.15-2.18,6.49-15.81-13.55-19.48s-92.33,17.79-92.33,17.79c0,0-38.68,11.58-66.07,39.53s0,53.65,0,53.65c0,0,9.55,10.88,23.2,13.77l11.58,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M378.77,307.11s25.97,5.77,25.59,16.5c-.46,13.21-15.58,26.96-35.44,39.39,0,0-30.96,20.61-70.45,33.74-31.29,10.41-41.3,11.87-45.2,12.38-.97.13-6.03,1.49-6.78,2.12-2.02,1.71-5.15,3.18-4.87,12.64s4.52,14.82,17.69,18c15.74,3.79,69.74-4.8,69.74-4.8,0,0,58.87-10.54,90.78-39.62,14.03-12.79,19.95-21.84,21.08-41.69s-16.56-32.28-16.56-32.28c0,0-16.32-12.88-45.59-16.36Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M846.53,294.38l29.09.17c21.58.13,36.22,14.4,36.08,35.67-.14,21.27-14.96,35.37-36.54,35.24l-29.09-.17.46-70.91ZM874.66,354.31c14.83.09,21.49-9.48,21.58-24.17.09-14.69-6.44-24.37-21.27-24.46l-14.16-.1-.31,48.62,14.16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M966.86,344.32l-35.46-.24c1.33,7.8,5.27,12.55,13.8,12.88,6.03.23,16.84-1.84,20.35-5.71l.1,11.73c-7.78,4.24-12.35,4.62-20.79,4.56-16.43-.1-28.27-11.72-28.17-27.6.1-15.88,12.17-27.12,26.77-27.03,14.32.09,23.72,11.04,23.61,27.71,0,1-.11,2.5-.21,3.69ZM931.36,335.8l21.81.17c-.87-7.69-5.47-11.22-10.78-11.06s-9.88,3.11-11.03,10.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1024.11,314.85l-19.42,51.41-18.43-.07-18.71-51.66,16.53.07,11.73,38.31,12.74-38.12,15.57.07Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M475.3,362.73l.11-13.39c5.12,4.63,15.47,7.64,28.13,6.92,7.41-.43,11.28-4.01,11.17-9.36-.28-13.75-40.67-6.35-40.04-33.08.32-13.52,13.23-20.49,30.79-20.49,7.68,0,12.4,1.13,18.3,4.37l.25,13.39c-5.76-3.8-13.07-5.65-18.65-5.65-9.87,0-13.9,3.32-13.9,8.77,0,15.32,37.64,2.28,37.94,31.77.12,11.51-8.32,21.38-25.87,21.38-9.97,0-13.96.99-28.24-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M534.3,340.9c0-15.99,10.97-27.15,26.42-27.28,9.75-.09,15.12,1.42,18.84,4.39l.23,11.6c-6.5-4.31-14.19-4.04-19.02-3.65-6.82.55-11.05,5.55-10.96,14.95.1,10.39,6.4,15.69,14.81,15.69,4.85,0,9.42-.24,15.16-4.19l-.09,11.86c-5.34,2.73-10.92,3.86-18.97,4.03-17.35.37-26.42-11.39-26.42-27.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M789.83,341.46c0-15.99,10.97-27.15,26.42-27.28,9.75-.09,15.12,1.42,18.84,4.39l.23,11.6c-6.5-4.31-14.19-4.04-19.02-3.65-6.82.55-11.05,5.55-10.96,14.95.1,10.39,6.4,15.69,14.81,15.69,4.85,0,9.42-.24,15.16-4.19l-.09,11.86c-5.34,2.73-10.92,3.86-18.97,4.03-17.35.37-26.42-11.39-26.42-27.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M633.35,334.7v31.28h-12.79v-6.5c-2.74,4.6-7.05,8.04-14.36,8.2-17.33.38-21.2-6.7-21.2-15.99s9.49-16.89,24.3-16.89h10.62v-1.8c0-7.3-7.36-7.59-10.16-7.59-5.49,0-14.2,2.38-18.81,5.3l-.48-12.1c5.21-4.4,12.8-6.6,20.66-6.6,14.08,0,22.22,7.3,22.22,22.69ZM619.92,349.29v-4.2h-9.79c-7.77,0-9.89,3.2-9.87,7.1s3.47,5.39,9.33,5.39,8.42-2.8,10.34-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M694.62,336.94v28.71h-14.02v-27.21c0-8.91-4.43-12.35-12.12-12.14s-10.43,3.98-10.43,14.02v25.34h-14.02v-50.11h13.45v6.47c3.94-4.6,8.16-8,15.66-8,12.31,0,21.6,6.14,21.48,22.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M754.75,293.71v72.38h-13.2v-6.73c-2.92,5.13-3.78,7.71-14.88,8.23-17.98.85-24.85-11.35-24.85-27.55s10.73-26.63,25.2-26.63c6.44,0,10.13,2.24,14.05,7.02v-26.73h13.67ZM740.78,339.92c0-8-3.65-14.31-12.05-14.31-6.02,0-11.58,4.73-11.58,14.68s4.05,15.81,11.26,16.04c8.4.26,12.36-6.46,12.36-16.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M765.01,300.56c0-4.81,3.77-8.59,8.87-8.59s8.87,3.55,8.87,8.24c0,5.04-3.66,8.93-8.87,8.93s-8.87-3.78-8.87-8.59ZM767.13,315.38h14.43v50.4h-14.43v-50.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScandicdev);
export default __webpack_public_path__ + "static/media/scandicdev.569ea73eabe341cd459088e5ae38653d.svg";
export { ForwardRef as ReactComponent };